import { api, ApiRes } from './client'
import {
    NaturalProfile,
    NaturalProfileMinimal,
    NaturalProfileRequestBody,
    Signature,
} from '../account/useAccountDataPersonal'
import { LegalProfile, LegalProfileRequestBody } from '../account/useAccountDataLegal'
import { AxiosRequestConfig } from 'axios'
import { fileToBase64 } from '../helpers'
import useUtmParams from '../useUtmParams'

interface AccountsNaturalAccount {
    account_title: string
    account_type: string
    account_uid: string
    natural_profile_uid: string
    platform_name: string
}

interface AccountsLegalAccount {
    account_title: string
    account_type: string
    account_uid: string
    legal_profile_uid: string
    platform_name: string
}

export interface ApiAccountsResponse {
    natural_profile: NaturalProfile
    legal_profile: LegalProfile
    accounts: {
        natural: AccountsNaturalAccount[]
        legal: AccountsLegalAccount[]
    }
}
interface ApiLegalProfileResponse {
    legal_profile: LegalProfile
}

interface ApiNaturalProfileResponse {
    legal_profile: NaturalProfile
}

export interface LegalManager {
    first_name: string
    last_name: string
    email: string
    is_beneficial_owner: boolean
}

interface BeneficialOwner {
    first_name: string
    last_name: string
    email: string
    nationality: string
    country_of_birth: string
    city_of_birth: string
    country_of_residence: string
    date_of_birth: string
}

export const getAccounts = (): ApiRes<ApiAccountsResponse> => api.get('accounts')

/* Natural profile */

export const putNaturalProfile = (
    naturalProfileId: string,
    requestBody: NaturalProfileRequestBody
): ApiRes<ApiNaturalProfileResponse> => api.put('accounts/profiles/natural/' + naturalProfileId, requestBody)

export const refreshNaturalProfileSignatures = (naturalProfileId: string, accounturl: string): ApiRes<Signature[]> =>
    api.post('accounts/profiles/natural/' + naturalProfileId + '/signatures/regenerate?account_url=' + accounturl)

/* Legal profile */

export const refreshLegalProfileSignatures = (legalProfileId: string, accounturl: string): ApiRes<Signature[]> =>
    api.post('accounts/profiles/legal/' + legalProfileId + '/signatures/regenerate?account_url=' + accounturl)

export const postSignatureDocument = async (signatureId, file, config: AxiosRequestConfig = null) => {
    const encodedFile = await fileToBase64(file)
    return api.post('signatures/' + signatureId + '/upload', { image: encodedFile }, config)
}
export const putLegalProfile = (
    legalProfileId: string,
    requestBody: LegalProfileRequestBody
): ApiRes<ApiLegalProfileResponse> => api.put('accounts/profiles/legal/' + legalProfileId, requestBody)

export const postManager = (legalProfileId: string, requestBody: LegalManager): ApiRes<NaturalProfileMinimal> =>
    api.post('accounts/profiles/legal/' + legalProfileId + '/managers', requestBody)

export const putManager = (
    managerNaturalProfileId: string,
    requestBody: LegalManager
): ApiRes<ApiLegalProfileResponse> => api.put('accounts/profiles/managers/' + managerNaturalProfileId, requestBody)

export const postBeneficialOwner = (
    legalProfileId: string,
    requestBody: BeneficialOwner
): ApiRes<ApiLegalProfileResponse> =>
    api.post('accounts/profiles/legal/' + legalProfileId + '/beneficial_owner', requestBody)

export const deleteBeneficialOwner = (beneficialOwnerId: string): ApiRes<ApiLegalProfileResponse> =>
    api.delete('accounts/profiles/beneficial_owner/' + beneficialOwnerId)

const utmParams = useUtmParams()
export const createCompanyProfile = (): ApiRes<ApiLegalProfileResponse> =>
    api.post('accounts/companies', {
        ...utmParams,
    })
